export const APPBAR_HEIGHT = '3.5rem';
export const LEFT_NAVBAR_WIDTH = '4.5rem';
export const PAGE_HEADER_HEIGHT = '3.75rem';
export const USERS_TABS_HEIGHT = '2.5rem';
